import React from 'react';

const Input = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  placeholder,
  error,
  required = false,
  icon: Icon,
  disabled = false,
  className = '',
  ...props
}) => {
  const inputId = name || Math.random().toString(36).substr(2, 9);

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label
          htmlFor={inputId}
          className="block text-sm font-semibold text-[#1B263B] mb-2 font-display"
        >
          {label}
          {required && <span className="text-[#E85D04] ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        {Icon && (
          <div className="absolute left-4 top-1/2 -translate-y-1/2 text-[#7A756F] pointer-events-none">
            <Icon size={20} />
          </div>
        )}
        <input
          id={inputId}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          className={`
            w-full h-12
            ${Icon ? 'pl-12' : 'pl-4'} pr-4
            bg-white
            border-2 rounded-xl
            font-body text-[#1B263B]
            placeholder:text-[#9A9590]
            transition-all duration-200
            touch-manipulation
            ${error 
              ? 'border-[#DC2626] focus:border-[#DC2626] focus:ring-2 focus:ring-red-100' 
              : 'border-[#EFEDEA] focus:border-[#E85D04] focus:ring-2 focus:ring-[#E85D04]/10'
            }
            ${disabled ? 'bg-[#F8F7F5] cursor-not-allowed' : ''}
            focus:outline-none
          `}
          {...props}
        />
      </div>
      {error && (
        <p className="mt-2 text-sm text-[#DC2626] font-medium animate-fadeIn">
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;
